import { createAction, props } from '@ngrx/store';
import { MspDattoCreds } from './model';

export const loadMspDattoCreds = createAction('[MSP Datto] Load Creds');
export const loadMspDattoCredsSuccess = createAction(
    '[MSP Datto] Load Creds Success',
    props<{ data: MspDattoCreds; connected: boolean }>(),
);
export const loadMspDattoCredsFailure = createAction('[MSP Datto] Load Creds Failure', props<{ error: any }>());

export const createMspDattoCreds = createAction('[MSP Datto] Create Creds', props<{ data: MspDattoCreds }>());
export const createMspDattoCredsSuccess = createAction(
    '[MSP Datto] Create Creds Success',
    props<{ data: MspDattoCreds }>(),
);
export const createMspDattoCredsFailure = createAction('[MSP Datto] Create Creds Failure', props<{ error: any }>());

export const putMspDattoCreds = createAction('[MSP Datto] Put Creds', props<{ data: MspDattoCreds }>());
export const putMspDattoCredsSuccess = createAction('[MSP Datto] Put Creds Success', props<{ data: MspDattoCreds }>());
export const putMspDattoCredsFailure = createAction('[MSP Datto] Put Creds Failure', props<{ error: any }>());

export const deleteMspDattoIntegration = createAction('[MSP Datto] Delete Integration');
export const deleteMspDattoIntegrationSuccess = createAction('[MSP Datto] Delete Integration Success');
export const deleteMspDattoIntegrationFailure = createAction(
    '[MSP Datto] Delete Integration Failure',
    props<{ error: any }>(),
);
